import { useEffect, useRef } from 'react';
import { api } from '@/lib/api';
import { APP_ID } from '@/lib/launch';

/**
 * Reports one session to the adoption endpoint.
 *
 * Fires once per mount of the signed-in shell — a page navigation inside the
 * SPA is the same session and must not inflate the count, which is why the
 * ping lives here rather than in a route effect.
 *
 * Deliberately fire-and-forget and deliberately silent: adoption telemetry is
 * the least important request the app makes, and a failed one must never
 * surface to the person using it or block the page. React's StrictMode double-
 * invokes effects in development, so a ref guards against the duplicate.
 */
export function useReportAppVisit(): void {
  const reported = useRef(false);

  useEffect(() => {
    if (reported.current) return;
    reported.current = true;

    api.post('/telemetry/app-visit', { app: APP_ID }).catch(() => {
      // Telemetry is best-effort. A dropped ping costs one session in a
      // report; a surfaced error would cost trust in a working page.
    });
  }, []);
}
